var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.openFilter)?_c('v-card',{staticClass:"grey lighten-3",attrs:{"height":"110px","flat":""}},[_c('v-card-text',[_c('v-layout',{staticClass:"pa-0 my-0",attrs:{"row":"","wrap":""}},[_vm._t("default",null,{"scope":"filterContent"})],2)],1)],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }